import { Button } from '@workspace/ui/components/Button';
import { Typography } from '@workspace/ui/components/Typography';
import { cn } from '@workspace/ui/lib/utils';
import type React from 'react';
import { useTranslation } from 'react-i18next';

import { company } from '~/company/Company';
import Icon from '~/components/Icon/Icon';

interface EmptySearchStateProps
  extends Omit<React.ComponentPropsWithoutRef<'div'>, 'children'> {
  handleExploreCatalog?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const EmptySearchState: React.FC<EmptySearchStateProps> = ({
  handleExploreCatalog,
  className,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <div
      {...props}
      className={cn(
        'flex flex-col items-center justify-center gap-4 text-center',
        className,
      )}
    >
      <img
        src={company.images.header.search.empty}
        className="h-[88px] w-auto text-navigation-icon-secondary"
        alt=""
      />
      <Typography.Text300Regular className="m-0 text-navigation-text-primary">
        {t('header:cantFindWhatYouAreLookingFor')}
      </Typography.Text300Regular>
      {handleExploreCatalog && (
        <Button
          variant="brand"
          size="lg"
          endIcon={<Icon type="chevron-3.1" size={11} className="rotate-180" />}
          className="mx-auto mt-2 mb-6 min-w-[205px] px-5 py-[14px]"
          onClick={handleExploreCatalog}
        >
          {t('header:exploreOurCatalog')}
        </Button>
      )}
    </div>
  );
};
